import { gql } from 'urql';
import { PRODUCT } from '../client';

export const UPDATE_LOCATIONS_INCLUDE_FINANCIALS_ON_DELIVERY_SHEET = gql`
  mutation ${PRODUCT}UpdateLocationsIncludeFinancialsOnDeliverySheet($input: LocationsIncludeFinancialsOnDeliverySheetUpdateInput!) {
    updateLocationsIncludeFinancialsOnDeliverySheet(input: $input) {
      locations {
        id
        includeFinancialsOnDeliverySheet
      }
    }
  }
`;
